import { SEARCH } from 'constants/FilterConstants';

import * as types from 'modules/contactMembers/actionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  text?: string,
 * }} FiltersState
 */

/** @type {FiltersState} */
const emptyState = {
  [SEARCH]: null,
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<FiltersState>} */
const filterAdapter = filterSliceAdapter(emptyState);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_CONTACT_MEMBERS_FILTER]: filterAdapter.setFilter,
  [types.SET_CONTACT_MEMBERS_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CONTACT_MEMBERS_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CONTACT_MEMBERS_FILTER]: filterAdapter.removeFilter,
});
